var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 14.5,
    fill: "#37715B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.935 15.7959C13.6952 15.9561 13.4133 16.0417 13.1248 16.0417C12.7381 16.0417 12.3671 15.888 12.0936 15.6145C11.8201 15.341 11.6665 14.9701 11.6665 14.5833C11.6665 14.2949 11.752 14.0129 11.9123 13.7731C12.0725 13.5333 12.3003 13.3464 12.5668 13.236C12.8332 13.1256 13.1265 13.0968 13.4093 13.153C13.6922 13.2093 13.9521 13.3482 14.156 13.5521C14.36 13.7561 14.4989 14.0159 14.5551 14.2988C14.6114 14.5817 14.5825 14.8749 14.4722 15.1414C14.3618 15.4079 14.1749 15.6357 13.935 15.7959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0646 13.3708C21.3045 13.2105 21.5864 13.125 21.8748 13.125C22.2616 13.125 22.6325 13.2786 22.906 13.5521C23.1795 13.8256 23.3332 14.1966 23.3332 14.5833C23.3332 14.8718 23.2476 15.1537 23.0874 15.3935C22.9272 15.6334 22.6994 15.8203 22.4329 15.9307C22.1664 16.041 21.8732 16.0699 21.5903 16.0136C21.3074 15.9574 21.0476 15.8185 20.8436 15.6145C20.6397 15.4106 20.5008 15.1507 20.4445 14.8678C20.3883 14.585 20.4171 14.2917 20.5275 14.0253C20.6379 13.7588 20.8248 13.531 21.0646 13.3708Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 21.5943C19.288 21.5943 20.5372 21.1534 21.5399 20.3449C21.8463 20.0903 22.2412 19.9678 22.6378 20.0044C22.8342 20.0225 23.0251 20.0791 23.1996 20.171C23.3741 20.2629 23.5289 20.3882 23.6549 20.5399C23.9095 20.8462 24.032 21.2412 23.9955 21.6378C23.9589 22.0345 23.7663 22.4003 23.4599 22.6549C21.9279 23.9338 19.9956 24.6344 17.9999 24.6344C16.0043 24.6344 14.0719 23.9338 12.5399 22.6549C12.2336 22.4003 12.041 22.0345 12.0044 21.6378C11.9678 21.2412 12.0903 20.8462 12.3449 20.5399C12.5995 20.2336 12.9654 20.041 13.362 20.0044C13.7587 19.9678 14.1536 20.0903 14.4599 20.3449C15.4626 21.1534 16.7119 21.5943 17.9999 21.5943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappySelected);
export default __webpack_public_path__ + "static/media/happy-selected.2030f4572607b4d7bcdc0ba2099569a4.svg";
export { ForwardRef as ReactComponent };